"use strict";
/* eslint-disable functional/no-loop-statement */
/* eslint-disable functional/no-let */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCsrfToken = void 0;
const VERSION = 'v1'; // 区分版本号
/**
 * 计算 csrfToken
 * @param autoToken 会话 token
 * @returns csrfToken
 */
function getCsrfToken(autoToken) {
    if (!autoToken) {
        return '';
    }
    const timestamp = parseInt(`${Date.now() / 1000}`); // 时间戳到秒
    autoToken = String(autoToken + timestamp);
    let hash = 5381;
    for (let i = 0, len = autoToken.length; i < len; i += 1) {
        hash += (hash << 5) + autoToken.charCodeAt(i);
    }
    return `${VERSION}-${timestamp}-${hash & 0x7fffffff}`;
}
exports.getCsrfToken = getCsrfToken;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3NyZi10b2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdXRpbHMvY3NyZi10b2tlbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsaURBQWlEO0FBQ2pELHNDQUFzQzs7O0FBSXRDLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxDQUFDLFFBQVE7QUFFOUI7Ozs7R0FJRztBQUNILFNBQWdCLFlBQVksQ0FBQyxTQUFpQjtJQUM1QyxJQUFJLENBQUMsU0FBUyxFQUFFO1FBQ2QsT0FBTyxFQUFFLENBQUM7S0FDWDtJQUVELE1BQU0sU0FBUyxHQUFHLFFBQVEsQ0FBQyxHQUFHLElBQUksQ0FBQyxHQUFHLEVBQUUsR0FBRyxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUMsUUFBUTtJQUM1RCxTQUFTLEdBQUcsTUFBTSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUMsQ0FBQztJQUUxQyxJQUFJLElBQUksR0FBRyxJQUFJLENBQUM7SUFDaEIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxHQUFHLFNBQVMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3ZELElBQUksSUFBSSxDQUFDLElBQUksSUFBSSxDQUFDLENBQUMsR0FBRyxTQUFTLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQy9DO0lBRUQsT0FBTyxHQUFHLE9BQU8sSUFBSSxTQUFTLElBQUksSUFBSSxHQUFHLFVBQVUsRUFBRSxDQUFDO0FBQ3hELENBQUM7QUFkRCxvQ0FjQyJ9